/**
 * Present Xcotton's existing checkout choices clearly without replacing its
 * handlers, calculating insurance prices, or changing the cart/checkout flow.
 * Xcotton and the theme both replace this markup after cart updates.
 */
(() => {
  if (window.__valyouCartClarityInitialized) return;
  window.__valyouCartClarityInitialized = true;

  const protectedSelector = '[data-xmh-checkout="true"]';
  const standardSelector = '[data-xmh-checkout-without="true"]';
  const connectedRoots = new WeakSet();

  function setDirectLabel(element, label) {
    if (!element) return;
    // Preserve the app's amount span, icon, listeners and loading indicator.
    const text = [...element.childNodes].find(
      (node) => node.nodeType === Node.TEXT_NODE && node.textContent.trim()
    );
    if (text && text.textContent !== label) text.textContent = label;
  }

  function clarifyCart(root) {
    if (root.id === 'cart-drawer') {
      document.documentElement.classList.toggle(
        'valyou-cart-drawer-open', root.hasAttribute('open')
      );
    }

    root.querySelectorAll(protectedSelector).forEach((protectedButton) => {
      const form = protectedButton.closest('form');
      if (!form || !root.contains(form)) return;

      const container = form.parentElement;
      // Both live cart forms have their own container. Do not pair a checkout
      // with another form's no-protection button on the full cart page.
      const standardButton = [...container.querySelectorAll(standardSelector)]
        .find((button) => button.parentElement === container || button.closest('form') === form);
      if (!standardButton) return;

      protectedButton.classList.add('valyou-cart-protected-checkout');
      standardButton.classList.add('valyou-cart-standard-checkout');
      form.classList.add('valyou-cart-actions');

      setDirectLabel(
        protectedButton.querySelector('[data-xcotton-checkout-mode="checkout-plus"]'),
        'Add protection & checkout • approx. '
      );

      const protectionCard = [...container.children].find(
        (element) => element.id === 'xcottonWrapper'
      ) || form.querySelector('#xcottonWrapper');
      setDirectLabel(
        protectionCard?.querySelector('.xcotton_bd_title_txt'),
        ' Optional shipping protection '
      );
      if (protectionCard && !protectionCard.querySelector('.valyou-cart-protection-note')) {
        const note = document.createElement('p');
        note.className = 'valyou-cart-protection-note';
        note.textContent = 'Estimated price. Final protection price is confirmed at checkout.';
        protectionCard.append(note);
      }

      if (root.id === 'cart-drawer') {
        // Move the genuine app button, rather than cloning it or bypassing the
        // handler that removes shipping protection. DOM and keyboard order agree.
        const insertionPoint = protectionCard?.parentElement === container
          ? protectionCard : form;
        if (standardButton.nextElementSibling !== insertionPoint) {
          container.insertBefore(standardButton, insertionPoint);
        }

        const viewCart = [...form.children].find(
          (element) => element.matches('a.button[href]')
        );
        if (viewCart) {
          viewCart.classList.add('valyou-cart-view-cart');
          if (form.lastElementChild !== viewCart) form.append(viewCart);
        }
      } else if (standardButton.parentElement === container) {
        // Keep full-cart totals above their checkout choices. The app's button
        // is type=button, so moving it inside the same cart form preserves its
        // checkout handler and does not create a second submission path.
        form.insertBefore(standardButton, protectedButton);
      } else if (standardButton.nextElementSibling !== protectedButton) {
        protectedButton.before(standardButton);
      }
    });
  }

  function connectRoots() {
    document.querySelectorAll('#cart-drawer, body.template-cart .cart').forEach((root) => {
      if (connectedRoots.has(root)) return;
      connectedRoots.add(root);
      let scheduled = false;
      const schedule = () => {
        if (scheduled) return;
        scheduled = true;
        requestAnimationFrame(() => {
          scheduled = false;
          if (root.isConnected) clarifyCart(root);
        });
      };

      new MutationObserver((mutations) => {
        // The cart countdown changes every second; it is unrelated to checkout.
        if (mutations.every((mutation) => {
          const element = mutation.target.nodeType === Node.ELEMENT_NODE
            ? mutation.target : mutation.target.parentElement;
          return element?.closest('#cart_timer_check');
        })) return;
        schedule();
      }).observe(root, {
        childList: true, subtree: true, characterData: true,
        attributes: true, attributeFilter: ['open']
      });

      clarifyCart(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', connectRoots, { once: true });
  } else {
    connectRoots();
  }
  document.addEventListener('shopify:section:load', connectRoots);
})();
